import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { TasksPreview } from "@/components/TasksPreview";

interface TasksPreviewWrapperProps {
  northId: string;
  showOnReport: boolean;
  viewMode: "mobile" | "desktop";
}

export function TasksPreviewWrapper({
  northId,
  showOnReport,
  viewMode,
}: TasksPreviewWrapperProps) {
  const { data: tasks, isLoading } = useQuery({
    queryKey: ["tasks-preview", northId],
    staleTime: 0,
    gcTime: 0,
    queryFn: async () => {
      const { data, error } = await (supabase
        .from("listing_tasks" as any)
        .select("*")
        .eq("north_id", northId)
        .order("activity_date", { ascending: false }) as any);

      if (error) throw error;
      return (data || []) as any[];
    },
  });

  if (!showOnReport) return null;
  if (isLoading) return null;

  const hasData = tasks && tasks.length > 0;
  if (!hasData) return null;

  return (
    <div
      className={`rounded-xl bg-gradient-to-br from-primary/5 via-primary/10 to-background border border-border/50 shadow-sm ${
        viewMode === "mobile" ? "mb-8 p-6" : "mb-12 p-8"
      }`}
    >
      <TasksPreview northId={northId} />
    </div>
  );
}
